export default __webpack_public_path__ + "static/dynamodb-ee8c5b13819e0a4b2b9a7369108fb89c.png";